<template>
    <div
        ref="paralaxContainer"
        v-if="kravicka.kravicka_pozadie"
        v-html="kravicka.kravicka_pozadie.herny_produkt_popis_produktu"
    >
    </div>
</template>

<script>
    import Parallax from "parallax-js"

    export default {
        props: [
            'kravicka'
        ],
        data() {
            return {
            }
        },
        mounted() {
            this.initParalax()
        },
        updated() {
            this.initParalax()
        },

        computed: {
        },
        methods: {
            initParalax() {
                let paralaxContainer = this.$refs.paralaxContainer

                if ( paralaxContainer !== undefined ) {
                    new Parallax(paralaxContainer.childNodes[0])
                }
            }
        }
    }
</script>